import React from "react";

const AboutPage = () => {
  return (
    <div className="page-container about-page">
      <h1>About Our Platform</h1>

      <p>
        Our platform helps people discover great places to eat, drink, stay,
        and socialize. We curate and list cafés, restaurants, bars, clubs,
        and hotels to make it easier for you to find the best spots in the city.
      </p>

      <p>
        Whether you're looking for a cozy coffee shop, a top-rated restaurant,
        a lively bar, or a comfortable hotel, our goal is to help you explore
        the best hospitality venues all in one place.
      </p>

      <p>
        We focus on providing clear information, helpful reviews, and
        curated recommendations so you can confidently choose where to go next.
      </p>

      <p>
        Our mission is to make discovering great hospitality experiences
        simple, transparent, and enjoyable for everyone.
      </p>
    </div>
  );
};

export default AboutPage;